export default __webpack_public_path__ + "static/media/manga.6adec14b.otf";